"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bar = require("@nivo/bar");

var _Grid = _interopRequireDefault(require("./layers/Grid"));

var _Axes = _interopRequireDefault(require("./layers/Axes"));

var _Bars = _interopRequireDefault(require("./layers/Bars"));

var _BarsItem = _interopRequireDefault(require("./layers/BarsItem"));

var _ChartBarTooltip = _interopRequireDefault(require("./ChartBarTooltip"));

require("./ChartBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ChartBar extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      currentBar: undefined
    });

    _defineProperty(this, "setCurrentBar", (bar, event) => {
      this.setState({
        currentBar: bar
      });
    });

    _defineProperty(this, "getAxisTop", () => {
      return null;
    });

    _defineProperty(this, "getAxisRight", () => {
      const _this$props = this.props,
            axisRight = _this$props.axisRight,
            margin = _this$props.margin,
            yFormat = _this$props.yFormat,
            gridYValues = _this$props.gridYValues;
      let tickSize;
      return _extends({
        format: yFormat,
        tickSize: margin.right || 0,
        tickValues: gridYValues
      }, axisRight);
    });

    _defineProperty(this, "getAxisBottom", () => {
      const _this$props2 = this.props,
            axisBottom = _this$props2.axisBottom,
            xTickValues = _this$props2.xTickValues,
            xFormat = _this$props2.xFormat,
            dimension = _this$props2.dimension,
            startDate = _this$props2.startDate,
            endDate = _this$props2.endDate;
      return _extends({
        dimension: dimension,
        startDate: startDate,
        endDate: endDate,
        format: xFormat,
        tickSize: 5,
        tickValues: xTickValues || undefined
      }, axisBottom);
    });

    _defineProperty(this, "getAxisLeft", () => {
      return null;
    });

    _defineProperty(this, "renderAxes", props => {
      const width = props.width,
            height = props.height,
            innerWidth = props.innerWidth,
            innerHeight = props.innerHeight,
            xScale = props.xScale,
            yScale = props.yScale,
            axisTop = props.axisTop,
            axisRight = props.axisRight,
            axisBottom = props.axisBottom,
            axisLeft = props.axisLeft;
      return _react.default.createElement(_Axes.default, {
        key: "axes",
        width: width,
        height: height,
        xScale: xScale,
        yScale: yScale,
        top: axisTop,
        right: axisRight,
        bottom: axisBottom,
        left: axisLeft
      });
    });

    _defineProperty(this, "renderGrid", props => {
      const width = props.width,
            height = props.height,
            innerWidth = props.innerWidth,
            innerHeight = props.innerHeight,
            enableGridX = props.enableGridX,
            enableGridY = props.enableGridY,
            xScale = props.xScale,
            yScale = props.yScale,
            gridXValues = props.gridXValues,
            gridYValues = props.gridYValues;
      return _react.default.createElement(_Grid.default, {
        key: "grid",
        width: width,
        height: height,
        xScale: enableGridX ? xScale : null,
        yScale: enableGridY ? yScale : null,
        xValues: gridXValues,
        yValues: gridYValues
      });
    });

    _defineProperty(this, "renderBars", props => {
      const currentBar = this.state.currentBar;
      const renderTooltip = props.renderTooltip,
            onTooltip = props.onTooltip;
      return _react.default.createElement(_Bars.default, _extends({}, props, {
        current: currentBar,
        setCurrent: this.setCurrentBar,
        tooltip: this.renderTooltip
      }));
    });

    _defineProperty(this, "getLayers", () => {
      return [this.renderGrid, this.renderAxes, //            this.renderBars,
      'bars', 'markers', 'legends', 'annotations', 'legends'];
    });

    _defineProperty(this, "getMargin", () => {
      const _this$props3 = this.props,
            outerMargin = _this$props3.outerMargin,
            margin = _this$props3.margin;

      if (outerMargin && margin) {
        return {
          top: outerMargin.top + margin.top,
          right: outerMargin.right + margin.right,
          bottom: outerMargin.bottom + margin.bottom,
          left: outerMargin.left + margin.left
        };
      }

      return margin;
    });

    _defineProperty(this, "renderTooltip", props => {
      if (this.props.renderTooltip) {
        return this.props.renderTooltip(props);
      }

      return _react.default.createElement(_ChartBarTooltip.default, _extends({}, this.props, {
        bar: props
      }));
    });

    _defineProperty(this, "getProps", () => {
      return _extends({}, this.props, {
        layers: this.getLayers(),
        axisTop: this.getAxisTop(),
        axisRight: this.getAxisRight(),
        axisBottom: this.getAxisBottom(),
        axisLeft: this.getAxisLeft(),
        tooltip: this.renderTooltip,
        barComponent: _BarsItem.default,
        margin: this.getMargin()
      });
    });
  }

  render() {
    const props = this.getProps();
    console.log('BAR DATA', props);
    return _react.default.createElement(_bar.ResponsiveBar, props);
  }

}

_defineProperty(ChartBar, "defaultProps", {
  data: [],
  keys: [],
  theme: {},
  groupMode: "grouped",
  padding: 0.1,
  innerPadding: 0,
  margin: {
    top: 0,
    right: 60,
    bottom: 60,
    left: 0
  },
  offset: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  xFormat: "date",
  yFormat: "integer",
  xScale: {
    type: "point"
  },
  yScale: {
    type: "linear",
    stacked: false,
    min: 0,
    max: 'auto'
  },
  gridXValues: 5,
  gridYValues: 5,
  enableGridX: false,
  enableGridY: true,
  enableLabel: false,
  animate: false
});

var _default = ChartBar;
exports.default = _default;
module.exports = exports.default;